import { observer } from "mobx-react-lite";

import ChooseEntityDialog from "@/components/ChooseEntityDialog";
import { Entity, EntityType } from "@/queries";

interface SelectWorkflowProps {
  workflow?: Partial<Entity<EntityType.WORKFLOW>>;
  onSelect: (workflow: Entity<EntityType.WORKFLOW>) => void;
  disabled?: boolean;
  readonly?: boolean;
  isLoading?: boolean;
  onCreateNew?: () => void;
  onEditWorkflow?: () => void;
  selectLatest?: boolean;
  url?: string;
  hasError?: boolean;
  errorMessage?: string;
}

function SelectWorkflow({
  workflow,
  onSelect,
  disabled = false,
  readonly,
  isLoading = false,
  onCreateNew,
  selectLatest = true,
  hasError = false,
  errorMessage,
  onEditWorkflow,
  url,
}: SelectWorkflowProps) {
  const selectedEntity: Entity | undefined = workflow
    ? ({
        ...workflow,
        type: EntityType.WORKFLOW,
        path: [],
      } as Entity)
    : undefined;

  const isReadonlyState = readonly ?? disabled;

  return (
    <div className="w-full">
      <ChooseEntityDialog
        type={EntityType.WORKFLOW}
        onSelect={onSelect as (entity: Entity) => void}
        selectedEntity={selectedEntity}
        config={{
          selectLatest,
        }}
        hasError={hasError}
        errorMessage={errorMessage}
        currentFolderId={workflow?.folder_id ?? null}
        readonly={isReadonlyState}
        isLoading={isLoading}
        onInlineCreate={onCreateNew}
        onInlineEdit={onEditWorkflow}
        url={url}
      />
    </div>
  );
}

export default observer(SelectWorkflow);
